<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <u-loader v-if="isLoading" />

    <div
      v-show="!isLoading"
      class="mb-2 row"
    >
      <div
        class="col-11"
        style="overflow: auto"
      >
        <div class="d-flex">
          <div
            class="mr-4"
            style="max-width: 25px"
          >
            <div
              v-if="
                validationObject.lastValidated &&
                  validationObject.lastValidationSuccesful
              "
            >
              <div
                v-b-tooltip.hover
                :title="
                  'Zuletzt validiert: ' +
                    formatDate(validationObject.lastValidated)
                "
                class="validationSuccess"
                placement="bottom"
              >
                <i class="fas fa-check" />
              </div>
            </div>
            <div v-if="!validationObject.lastValidated">
              <div
                v-b-tooltip.hover
                class="validationNotRan"
                placement="bottom"
                title="Nicht validiert"
              >
                <i class="fas fa-exclamation" />
              </div>
            </div>
            <div
              v-if="
                validationObject.lastValidated &&
                  !validationObject.lastValidationSuccesful
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-b-modal="'errors' + validationObject.id"
                    class="validationFailed"
                    placement="bottom"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <i class="fas fa-times" />
                  </div>
                </template>
                <span>{{
                        "Zuletzt validiert: " +
                          formatDate(validationObject.lastValidated)
                      }}
                  <br>
                  Klicken für mehr Info
                </span>
              </v-tooltip>
            </div>
          </div>
          <div
            v-for="(
              validationEntry, validationEntryIndex
            ) in validationObject.validationEntries"
            :key="'valEntry_' + validationEntryIndex"
            :class="{
              fixedWidthProp: validationEntry.criteriaStructureId,
              notWidthProp: validationEntry.variableId,
            }"
            class="mr-4"
          >
            <div v-if="validationEntry.criteriaStructureId">
              <b>{{ getStructureName(validationEntry.criteriaStructure) }}</b>
            </div>
            <div v-if="validationEntry.variableId">
              <b>{{ getVariableName(validationEntry.variable) }}</b>
            </div>
            {{ validationEntry.value }}
          </div>
        </div>
      </div>
      <div class="col-1">
        <button
          v-if="canUserEdit"
          v-b-modal="'editValidation' + validationId"
          v-b-tooltip.hover
          class="btn btn-primary mb-2 mr-2 smallActionButton"
          placement="bottom"
          title="Validierung bearbeiten"
          type="button"
        >
          <i class="fas fa-edit" />
        </button>
        <button
          v-if="canUserEdit"
          v-b-tooltip.hover
          class="btn btn-success mb-2 mr-2 smallActionButton"
          placement="bottom"
          title="Validierung überprüfen"
          type="button"
          @click="runValidation()"
        >
          <i class="fas fa-play" />
        </button>
        <button
          v-if="canUserEdit"
          v-b-modal="'deleteValidation' + validationId"
          v-b-tooltip.hover
          class="btn btn-danger mb-2 smallActionButton"
          placement="bottom"
          title="Validierung löschen"
          type="button"
          @click="validationToDeleteId = validationId"
        >
          <i class="fas fa-trash-alt" />
        </button>
      </div>
      <hr class="my-2">
    </div>

    <b-modal
      :id="'errors' + validationObject.id"
      :ref="'errors' + validationObject.id"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      title="Validierungsfehler"
    >
      <div class="d-block mb-4">
        <ul>
          <li
            v-for="(error, errorindex) in validationObject.lastValidationErrors"
            :key="'error_' + errorindex"
          >
            <div
              style="white-space: pre-line"
              v-html="error"
            />
          </li>
        </ul>
      </div>
      <b-button
        variant="success"
        @click="hideModal('errors' + validationId)"
      >
        Ok
      </b-button>
    </b-modal>
    <b-modal
      :id="'deleteValidation' + validationId"
      :ref="'deleteValidation' + validationId"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      title="Validierung löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie diese Validierung löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteValidation()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('deleteValidation' + validationId)"
      >
        Abbrechen
      </b-button>
    </b-modal>
    <b-modal
      :id="'editValidation' + validationId"
      :ref="'editValidation' + validationId"
      :title="validationId != 0 ? 'Validation bearbeiten' : 'Neue Validation'"
      hide-footer
      no-fade
      size="xl"
      @click="setUpValidationEdit()"
    >
      <u-error-handling
        v-if="saveErrorObject"
        :error-object="saveErrorObject"
      />
      <u-loader v-if="isLoading || propertiesLoading > 0" />
      <div v-show="!isLoading && propertiesLoading <= 0">
        <div class="">
          <h4>Eingabe</h4>
          <div
            v-for="(structureItem, structureItemIndex) in structure"
            :key="'struct_' + structureItemIndex"
            class="row"
          >
            <div class="col-3 font-weight-bold mt-4">
              {{ getTitle(structureItem.contents) }}
            </div>
            <rule-criteria-autocomplete
              v-if="!isLoading"
              v-model="enteredValues"
              :all-values="enteredValues"
              :contract-id="contractId"
              :edition-id="configurationId"
              :structure-item="structureItem"
              :version-number="versionId"
              class="col-9"
              collection-name="entries"
              :load-fully-qualified-paths="true"
              @initialLoadCompleted="
                () => {
                  propertiesLoading--;
                }
              "
              @noValuesPossible="
                () => {
                  propertiesLoading--;
                }
              "
            />
          </div>
          <hr>
          <h4>Erwartete Resultate</h4>
          <div
            v-for="(variable, variableIndex) in variables"
            :key="'var_' + variableIndex"
            class="row"
          >
            <div class="col-3 font-weight-bold">
              <v-select
                v-model="variable.variableId"
                :items="filteredVariableOptions(variable.variableId)"
                item-text="name"
                item-value="id"
              />
            </div>
            <div class="col-9">
              <div class="d-flex">
                <v-text-field
                  v-model="variable.value"
                  class="w-100"
                />
                <button
                  v-b-tooltip.hover
                  class="btn mt-4 smallActionButton"
                  placement="bottom"
                  title="Variable löschen"
                  type="button"
                  @click="variables.splice(variableIndex, 1)"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-3">
              <v-select
                v-model="selectedVariableToAdd"
                :items="$store.state.mindestLohnKonfiguration.Variables.filter(variable => { return variables.filter(existingVariable => { return existingVariable.variableId == variable.id }).length == 0 })" 
                item-text="name"
                item-value="id"
              />
            </div> -->
            <div class="col-1">
              <button
                v-b-tooltip.hover
                class="btn mt-4 smallActionButton"
                placement="bottom"
                title="Variable hinzufügen"
                type="button"
                @click="addVariable()"
              >
                <i class="fas fa-plus" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        v-b-tooltip.hover
        class="btn btn-success ml-0 mt-4"
        placement="bottom"
        title="Alle Validierungen prüfen"
        type="button"
        @click="saveValidation()"
      >
        Speichern
      </button>
      <button
        v-b-tooltip.hover
        class="btn btn-danger ml-2 mt-4"
        placement="bottom"
        title="Abbrechen"
        type="button"
        @click="hideModal('editValidation' + validationId)"
      >
        Abbrechen
      </button>
    </b-modal>
  </div>
</template>

<script>
import RuleCriteriaAutocomplete from "@/components/minimum.wage/pages/Rules/RuleCriteriaAutocomplete.vue";
import {
  DeleteValidation,
  RunValidation,
  SaveValidation,
} from "@/services/minimum.wage.services/validation.minimum.wages.js";

export default {
  components: {
    RuleCriteriaAutocomplete,
  },
  props: {
    validationObject: {
      type: Object,
      required: true,
    },
    structure: {
      type: Array,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    configurationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      errorObject: null,
      saveErrorObject: null,
      enteredValues: { entries: [] },
      isLoading: false,
      propertiesLoading: 0,
      validationId: 0,
      validationToDeleteId: null,
      selectedVariableToAdd: null,
      variables: [],
      variableOptions: [],
      selectedVariableId: null,
    };
  },
  computed: {
    canUserEdit() {
      return (
        (this.$IsUserInRole("VertragsmanagementVerwaltung") ||
          (this.$IsUserInRole("VertragsmanagementUniaVertragsverantworlich") &&
            this.$store.state.mindestLohnKonfiguration.Tenants.find(
              (x) => x.id == 4,
            ))) &&
        this.$store.state.contractConfiguration.canUserEdit
      );
    },
  },
  watch: {
    variables: {
      handler(newVariables) {
        // Update the list of usedVariableIds whenever variables change
        this.usedVariableIds = newVariables.map(
          (variable) => variable.variableId,
        );
      },
      deep: true,
    },
  },
  created() {
    if (
      !this.$store.state.mindestLohnKonfiguration.Criteria ||
      this.$store.state.mindestLohnKonfiguration.Criteria.length === 0
    ) {
      this.$store.dispatch("getCriteria", {
        contractId: this.contractId,
        versionId: this.versionId,
        editionId: this.configurationId,
      });
    }
    this.setUpValidationEdit();
    this.variableOptions = this.$store.state.mindestLohnKonfiguration.Variables;
  },

  methods: {
    setUpValidationEdit() {
      this.isLoading = true;
      this.validationId = this.validationObject.id;

      this.propertiesLoading = this.structure.length;
      this.enteredValues = { entries: [] };
      this.variables = [];

      this.validationObject.validationEntries.map((structureItem) => {
        if (structureItem.criteriaStructureId) {
          this.enteredValues.entries.push({
            id: structureItem.id,
            criteriaStructureId: structureItem.criteriaStructureId,
            value: structureItem.value,
            criteriaListEntryId: structureItem.criteriaListEntryId,
            path: structureItem.path,
          });
        }

        if (structureItem.variableId) {
          this.variables.push({
            id: structureItem.id,
            variableId: structureItem.variableId,
            value: structureItem.value,
            criteriaListEntryId: null,
            path: structureItem.path,
          });
        }
      });

      // Make sure that every structureItem has a matching item.
      this.structure.map((structureItem) => {
        structureItem.criteriaStructureId = structureItem.id;

        var enteredValue = this.enteredValues.entries.filter((value) => {
          return value.criteriaStructureId == structureItem.id;
        });

        if (enteredValue.length == 0) {
          this.enteredValues.entries.push({
            id: 0,
            criteriaStructureId: structureItem.id,
            value: "",
            criteriaListEntryId: structureItem.criteriaListEntryId,
          });
        }
      });

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    formatDate(date) {
      var newDate = this.$moment(date).format("DD.MM.YYYY HH:mm");
      return newDate;
    },
    addVariable() {
      this.variables.push({
        id: 0,
        variableId: null,
        value: "",
        criteriaListEntryId: null,
      });
    },
    removeVariable(index) {
      this.variables.splice(index, 1);
    },
    filteredVariableOptions(selectedVariableId) {
      const usedVariableIds = this.variables.map(
        (variable) => variable.variableId,
      );
      return this.variableOptions.filter(
        (option) =>
          !usedVariableIds.includes(option.id) ||
          option.id === selectedVariableId,
      );
    },
    deleteValidation() {
      this.errorObject = null;

      DeleteValidation(
        this.contractId,
        this.versionId,
        this.configurationId,
        this.validationToDeleteId,
        () => {
          this.$emit("validationUpdated");
          this.hideModal("deleteValidation" + this.validationId);
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    runValidation() {
      this.errorObject = null;
      this.isLoading = true;

      RunValidation(
        this.contractId,
        this.versionId,
        this.configurationId,
        this.validationObject.id,
        () => {
          this.$emit("validationUpdated");
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    hideModal(modalId) {
      if (modalId == "editValidation" + this.validationId) {
        this.setUpValidationEdit();
      }

      this.$refs[modalId].hide();
    },
    saveValidation() {
      this.saveErrorObject = null;
      this.isLoading = true;

      setTimeout(() => {
        this.validationObject.validationEntries = [];

        // Add all structure Items and then add all variables
        this.enteredValues.entries.map((entry) => {
          this.validationObject.validationEntries.push(entry);
        });
        this.variables.map((variable) => {
          this.validationObject.validationEntries.push(variable);
        });

        SaveValidation(
          this.contractId,
          this.versionId,
          this.configurationId,
          this.validationObject,
          () => {
            this.isLoading = false;
            this.$emit("validationUpdated");
            this.hideModal("editValidation" + this.validationId);
          },
          (error) => {
            this.saveErrorObject = error;
            this.isLoading = false;
          },
        );
      }, 1);
    },
    getStructureName(structure) {
      if (structure != null && structure.name != null) {
        return structure.name;
      }

      return "...";
    },
    getVariableName(variable) {
      if (variable != null && variable.name != null) {
        return variable.name;
      }

      return "...";
    },
    getTitle(contents) {
      let counterContent = 0;
      let foundValue = "";
      contents.forEach((content) => {
        this.structure.forEach((structItem) => {
          if (
            structItem.criteriaStructureId == content.criteriaStructureId &&
            structItem.name.toLowerCase() ==
              content.value.replace(/\s/g, "").toLowerCase()
          ) {
            foundValue = content.value;
          }
        });
        counterContent++;
      });

      if (counterContent == contents.length) {
        return foundValue;
      }
    },
  },
};
</script>

<style scoped>
.fixedWidthProp {
  max-width: 150px;
  min-width: 150px;
}

.validationSuccess {
  background-color: #219600;
  width: 25px;
  color: white;
  height: 25px;
  padding-left: 4px;
  padding-top: 2px;
  font-size: 16px;
  border-radius: 30px;
}

.validationNotRan {
  background-color: #ffd900;
  width: 25px;
  color: black;
  height: 25px;
  padding-left: 10px;
  padding-top: 2px;
  font-size: 16px;
  border-radius: 30px;
}

.validationFailed {
  background-color: #ff0000;
  width: 25px;
  color: white;
  height: 25px;
  padding-left: 6px;
  padding-top: 0px;
  font-size: 18px;
  border-radius: 30px;
}

.smallActionButton {
  width: 28px;
  height: 28px;
  font-size: 17px;
  padding: 0px;
}
</style>
